import request from '@/utils/request'


// 查询设备类型信息列表
export function listDeviceType (query) {
  return request({
    url: '/saifuneng/saifuneng-device-type/list',
    method: 'get',
    params: query
  })
}

// 查询设备类型信息分页
export function pageDeviceType (query) {
  return request({
    url: '/saifuneng/saifuneng-device-type/page',
    method: 'get',
    params: query
  })
}

// 查询设备类型信息详细
export function getDeviceType (data) {
  return request({
    url: '/saifuneng/saifuneng-device-type/detail',
    method: 'get',
    params: data
  })
}

// 新增设备类型信息
export function addDeviceType (data) {
  return request({
    url: '/saifuneng/saifuneng-device-type/add',
    method: 'post',
    data: data
  })
}

// 修改设备类型信息
export function updateDeviceType (data) {
  return request({
    url: '/saifuneng/saifuneng-device-type/edit',
    method: 'post',
    data: data
  })
}

// 删除设备类型信息
export function delDeviceType (data) {
  return request({
    url: '/saifuneng/saifuneng-device-type/delete',
    method: 'post',
    data: data
  })
}

// 查询设备类型信息列表
export function customList (query) {
  return request({
    url: '/system/user/page',
    method: 'get',
    params: query
  })
}
